(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.MiniCartView = (function(superClass) {
    extend(MiniCartView, superClass);

    function MiniCartView() {
      return MiniCartView.__super__.constructor.apply(this, arguments);
    }

    MiniCartView.prototype.events = {
      "click .mini-cart-item-remove": "removeProduct"
    };

    MiniCartView.prototype.initialize = function() {
      return this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          "-o-transition": "oTransitionEnd",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
    };

    MiniCartView.prototype.removeProduct = function(e) {
      var item, itemRemoved, itemTitle, itemURL, variant;
      item = this.$(e.target).parent(".mini-cart-item");
      variant = item.data("variant");
      itemTitle = item.data("title");
      itemURL = item.data("url");
      itemRemoved = Theme.itemRemovedFromCart.replace("{{ item_title }}", "<a href='" + itemURL + "'>" + itemTitle + "</a>");
      return Shopify.removeItem(variant, (function(_this) {
        return function(cart) {
          if (Modernizr.csstransitions) {
            item.addClass("removing").one(_this.transitionend, function() {
              item.html("<span>" + itemRemoved + "</span>");
              return item.removeClass("removing").addClass("removed");
            });
          } else {
            item.html("<span>" + itemRemoved + "</span>").addClass("removed");
          }
          return _this.updateCart(cart);
        };
      })(this));
    };

    MiniCartView.prototype.updateCart = function(cart) {
      return $(".cart-count").html("<span class='cart-count-text'>" + Theme.cartText + "</span> (<span class='cart-count-number'>" + cart.item_count + "</span>)");
    };

    return MiniCartView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.HeaderView = (function(superClass) {
    extend(HeaderView, superClass);

    function HeaderView() {
      return HeaderView.__super__.constructor.apply(this, arguments);
    }

    HeaderView.prototype.events = {};

    HeaderView.prototype.initialize = function() {
      new MiniCartView({
        el: this.$(".mini-cart")
      });
      this.body = $(document.body);
      this.window = $(window);
      this.branding = this.$(".branding");
      this.headerTools = this.$(".header-tools");
      this.window.resize((function(_this) {
        return function() {
          ;
          _this.fixWonkyLogo();
          ;
          return _this.setSearchWidth();
        };
      })(this)).trigger("resize");
      ;
      this.window.on("scroll", (function(_this) {
        return function() {
          if (document.documentElement.offsetWidth > 1020) {
            if (!_this.body.hasClass("alternate-index-layout")) {
              return _this.triggerStickyHeader();
            }
          }
        };
      })(this));
      this.window.resize((function(_this) {
        return function() {
          if (document.documentElement.offsetWidth <= 1020 && !theme.ltIE9) {
            return _this.body.removeClass("sticky-header");
          }
        };
      })(this));
      return ;
    };

    HeaderView.prototype.setSearchWidth = function() {
      var searchWidth;
      searchWidth = this.$(".mini-cart-wrapper").outerWidth() + this.$(".checkout-link").outerWidth();
      this.$(".search-form").width(searchWidth);
      return this.setLogoPadding(searchWidth);
    };

    HeaderView.prototype.setLogoPadding = function(padding) {
      return this.branding.css({
        "paddingLeft": padding + 60,
        "paddingRight": padding + 60
      });
    };

    ;

    HeaderView.prototype.triggerStickyHeader = function() {
      var branding, cartCount, headerHeight;
      headerHeight = this.$el.outerHeight();
      if (this.window.scrollTop() > headerHeight) {
        this.body.addClass("sticky-header");
      } else {
        this.body.removeClass("sticky-header");
      }
      if (!Modernizr.csstransforms) {
        cartCount = $(".sticky-header .navigation .cart-count");
        cartCount.css({
          "marginTop": -(cartCount.height() / 2)
        });
        branding = $(".sticky-header .navigation .branding");
        return branding.css({
          "marginTop": -(branding.height() / 2)
        });
      }
    };

    ;

    HeaderView.prototype.fixWonkyLogo = function() {
      var branding, logo, logoHeight;
      if (theme.ltIE9) {
        return;
      }
      logoHeight = parseInt("");
      if (this.body.hasClass("alternate-index-layout")) {
        branding = this.body;
        logo = $(".logo-regular");
      } else {
        branding = this.$(".branding");
        logo = this.$(".logo-retina").is(":visible") ? this.$(".logo-retina") : this.$(".logo-regular");
      }
      return branding.imagesLoaded((function(_this) {
        return function() {
          var initialAspectRatio, newAspectRatio;
          initialAspectRatio = logo[0].naturalWidth / logo[0].naturalHeight;
          initialAspectRatio = Math.round(initialAspectRatio * 10) / 10;
          newAspectRatio = logo[0].width / logoHeight;
          newAspectRatio = Math.round(newAspectRatio * 10) / 10;
          if ((newAspectRatio !== initialAspectRatio) && (logo[0].height <= logoHeight)) {
            return logo.css({
              height: "auto"
            });
          } else {
            return logo.css({
              height: logoHeight
            });
          }
        };
      })(this));
    };

    return HeaderView;

  })(Backbone.View);

}).call(this);

(function() {
  ;

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.NavigationView = (function(superClass) {
    extend(NavigationView, superClass);

    function NavigationView() {
      return NavigationView.__super__.constructor.apply(this, arguments);
    }

    NavigationView.prototype.events = {
      "mouseover .mega-nav-list a": "swapMegaNavImages",
      "click .has-dropdown .enter-linklist": "enterMegaNavTier",
      "click .has-dropdown .back": "exitMegaNavTier",
      "mouseleave .has-mega-nav": "useDefaultImage"
    };

    NavigationView.prototype.initialize = function() {
      this.body = $(document.body);
      $(".navigation-toggle").on("click", (function(_this) {
        return function() {
          if (_this.body.hasClass("mobile-nav-open")) {
            return _this.toggleMobileNavigation("close");
          } else {
            return _this.toggleMobileNavigation("open");
          }
        };
      })(this));
      this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          "-o-transition": "oTransitionEnd",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
      return $(window).resize((function(_this) {
        return function() {
          _this.setupNavigation();
          if (document.documentElement.offsetWidth > 1020 && _this.body.hasClass("mobile-nav-open")) {
            $(".navigation-wrapper").removeClass("visible");
            _this.toggleMobileNavigation("close");
          }
          if (!Modernizr.csstransforms) {
            return _this.positionMegaNav();
          }
        };
      })(this)).trigger("resize");
    };

    NavigationView.prototype.setupNavigation = function() {
      if (document.documentElement.offsetWidth > 1020 || theme.ltIE9) {
        this.$el.removeClass("mobile").addClass("full-width");
        return this.$("li[data-mega-nav='true']").removeClass("has-dropdown").addClass("has-mega-nav");
      } else {
        this.$el.removeClass("full-width").addClass("mobile");
        return this.$("li[data-mega-nav='true']").removeClass("has-mega-nav").addClass("has-dropdown");
      }
    };

    NavigationView.prototype.swapMegaNavImages = function(e) {
      var image, imageAlt;
      image = this.$(e.target).parent().data("image-src");
      imageAlt = this.$(e.target).parent().data("image-alt");
      return this.$(".mega-nav-image img").attr("src", image).attr("alt", imageAlt);
    };

    NavigationView.prototype.positionMegaNav = function() {
      var megaNav, megaNavWidth;
      megaNav = this.$(".mega-nav");
      megaNavWidth = megaNav.outerWidth();
      return megaNav.css({
        "marginLeft": -(megaNavWidth / 2)
      });
    };

    NavigationView.prototype.toggleMobileNavigation = function(direction) {
      var navigationWrapper;
      navigationWrapper = $(".navigation-wrapper");
      if (direction === "open") {
        this.body.addClass("mobile-nav-open lock-scroll");
        this.$el.addClass("visible");
        navigationWrapper.addClass("visible background");
        this.$("> ul").addClass("in-view active");
        return this.setTierHeight();
      } else if (direction === "close") {
        this.$el.removeAttr("style");
        this.body.removeClass("mobile-nav-open");
        this.$el.removeClass("visible");
        if (Modernizr.csstransitions) {
          return navigationWrapper.removeClass("background").one(this.transitionend, (function(_this) {
            return function() {
              navigationWrapper.removeClass("visible");
              return _this.body.removeClass("lock-scroll");
            };
          })(this));
        } else {
          navigationWrapper.removeClass("background");
          navigationWrapper.removeClass("visible");
          return this.body.removeClass("lock-scroll");
        }
      }
    };

    NavigationView.prototype.enterMegaNavTier = function(e) {
      var targetLinklist;
      if (this.$el.hasClass("mobile")) {
        e.preventDefault();
      }
      targetLinklist = $(e.target).parent().data("linklist-trigger");
      this.$("ul").removeClass("active");
      this.$("ul[data-linklist='" + targetLinklist + "']").addClass("in-view active");
      this.$(e.target).closest("ul").addClass("out-of-view");
      return this.setTierHeight();
    };

    NavigationView.prototype.exitMegaNavTier = function(e) {
      var target;
      target = $(e.target);
      this.$("ul").removeClass("active");
      if (Modernizr.csstransitions) {
        target.closest("ul.out-of-view").removeClass("out-of-view").addClass("active").one(this.transitionend, (function(_this) {
          return function() {
            return target.closest("ul").removeClass("in-view");
          };
        })(this));
      } else {
        target.closest("ul.out-of-view").removeClass("out-of-view").addClass("active");
        target.closest("ul").removeClass("in-view");
      }
      return this.setTierHeight();
    };

    NavigationView.prototype.setTierHeight = function() {
      var brandingHeight, tierHeight, windowHeight;
      this.$el.scrollTop(0);
      windowHeight = window.innerHeight;
      brandingHeight = this.$(".branding").outerHeight();
      tierHeight = this.$("ul.active").outerHeight();
      if (windowHeight > tierHeight + brandingHeight) {
        return this.$el.css({
          "overflow-y": "hidden",
          "max-height": windowHeight,
          "height": "100%"
        });
      } else {
        return this.$el.css({
          "overflow-y": "scroll",
          "max-height": tierHeight + brandingHeight,
          "height": "100%"
        });
      }
    };

    NavigationView.prototype.useDefaultImage = function() {
      var megaNavImage;
      megaNavImage = this.$(".mega-nav-image img");
      return megaNavImage.attr("src", megaNavImage.data("image")).attr("alt", megaNavImage.data("alt"));
    };

    return NavigationView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.FooterView = (function(superClass) {
    extend(FooterView, superClass);

    function FooterView() {
      return FooterView.__super__.constructor.apply(this, arguments);
    }

    FooterView.prototype.events = {};

    FooterView.prototype.initialize = function() {
      return $(window).resize((function(_this) {
        return function() {
          if (document.documentElement.offsetWidth <= 1020) {
            return _this.setupFooter("mobile");
          } else {
            return _this.setupFooter();
          }
        };
      })(this)).trigger("resize");
    };

    FooterView.prototype.setupFooter = function(layout) {
      if (layout === "mobile") {
        return this.$(".mailing-list").prependTo(".upper-footer");
      } else {
        return this.$(".mailing-list").appendTo(".upper-footer");
      }
    };

    return FooterView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.AccountView = (function(superClass) {
    extend(AccountView, superClass);

    function AccountView() {
      return AccountView.__super__.constructor.apply(this, arguments);
    }

    AccountView.prototype.events = {
      "click .delete-address": "deleteAddress",
      "click .edit-address": "editAddress",
      "click .add-new-address": "addNewAddress",
      "click .toggle-forgetfulness": "recoverPassword",
      "change .address-country": "updateProvinceSelectText"
    };

    AccountView.prototype.initialize = function() {
      var body;
      body = $(document.body);
      if (body.hasClass("template-customers-addresses")) {
        this.prepareAddresses();
      }
      if (body.hasClass("template-customers-login")) {
        this.checkForReset();
      }
      if (window.location.hash === "#recover") {
        return this.recoverPassword();
      }
    };

    AccountView.prototype.recoverPassword = function() {
      this.$(".recover-password").toggle();
      return this.$(".customer-login").toggle();
    };

    AccountView.prototype.checkForReset = function() {
      if (this.$(".reset-check").data("successful-reset") === true) {
        return this.$(".successful-reset").show();
      }
    };

    AccountView.prototype.prepareAddresses = function() {
      var address, addressID, addresses, i, len, results;
      new Shopify.CountryProvinceSelector("address-country", "address-province", {
        hideElement: "address-province-container"
      });
      addresses = this.$(".customer-address");
      if (addresses.length) {
        results = [];
        for (i = 0, len = addresses.length; i < len; i++) {
          address = addresses[i];
          addressID = $(address).data("address-id");
          results.push(new Shopify.CountryProvinceSelector("address-country-" + addressID, "address-province-" + addressID, {
            hideElement: "address-province-container-" + addressID
          }));
        }
        return results;
      }
    };

    AccountView.prototype.deleteAddress = function(e) {
      var addressID;
      addressID = $(e.target).parents("[data-address-id]").data("address-id");
      return Shopify.CustomerAddress.destroy(addressID);
    };

    AccountView.prototype.editAddress = function(e) {
      var addressID;
      addressID = $(e.target).parents("[data-address-id]").data("address-id");
      this.$(".customer-address").removeClass("editing").find(".edit-address").removeClass("disabled");
      this.$(".customer-address[data-address-id='" + addressID + "']").addClass("editing").find(".edit-address").addClass("disabled");
      this.$(".customer-address-edit-form, .customer-new-address").addClass("hidden");
      return this.$(".customer-address-edit-form[data-address-id='" + addressID + "']").removeClass("hidden");
    };

    AccountView.prototype.addNewAddress = function() {
      this.$(".customer-address").removeClass("editing").find(".edit-address").removeClass("disabled");
      this.$(".customer-address-edit-form").addClass("hidden");
      return this.$(".customer-new-address").removeClass("hidden");
    };

    AccountView.prototype.updateProvinceSelectText = function() {
      return this.$(".address-province").siblings(".selected-text").text("-- " + Theme.pleaseSelectText + " --");
    };

    return AccountView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.BlogView = (function(superClass) {
    extend(BlogView, superClass);

    function BlogView() {
      return BlogView.__super__.constructor.apply(this, arguments);
    }

    BlogView.prototype.events = {
      "change .blog-sidebar select": "filterBlog"
    };

    BlogView.prototype.initialize = function() {
      var template;
      if ($(document.body).hasClass("template-blog")) {
        template = "blog";
      } else {
        template = "article";
      }
      if (!theme.ltIE9) {
        if (document.documentElement.offsetWidth <= 1020) {
          this.positionSidebar(template, "below");
        } else {
          this.positionSidebar(template);
        }
      }
      this.$el.imagesLoaded((function(_this) {
        return function() {
          _this.setupFeaturedImage();
          return _this.setupFullWidthImages();
        };
      })(this));
      return $(window).resize((function(_this) {
        return function() {
          _this.setupFullWidthImages();
          if (!theme.ltIE9) {
            if (document.documentElement.offsetWidth <= 1020) {
              return _this.positionSidebar(template, "below");
            } else {
              _this.positionSidebar(template);
              return _this.setupFeaturedImage("position-only");
            }
          } else {
            return _this.setupFeaturedImage("position-only");
          }
        };
      })(this));
    };

    ;

    BlogView.prototype.setupFeaturedImage = function(setup) {
      var i, image, len, post, ref, results;
      ref = this.$(".blog-post");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        post = ref[i];
        post = $(post);
        image = post.find("img.highlight").first();
        if (image.length) {
          if (setup === "position-only") {
            results.push(post.find(".blog-post-inner").css({
              "paddingTop": image.height() - 60
            }));
          } else {
            results.push(post.prepend(image).addClass("has-featured-image").find(".blog-post-inner").css({
              "paddingTop": image.height() - 60
            }));
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    BlogView.prototype.setupFullWidthImages = function() {
      var i, image, len, postContent, postContentMargin, postContentWidth, ref, results;
      postContent = this.$(".post-content");
      postContentWidth = postContent.outerWidth(true);
      postContentMargin = postContent.css("marginLeft");
      ref = this.$("img.full-width");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        image = ref[i];
        image = $(image);
        results.push(image.css({
          "width": postContentWidth,
          "left": "-" + postContentMargin
        }));
      }
      return results;
    };

    BlogView.prototype.positionSidebar = function(template, position) {
      var sidebar;
      sidebar = this.$(".blog-sidebar");
      switch (template) {
        case "blog":
          if (position === "below") {
            return sidebar.insertAfter(".blog-posts");
          } else {
            return sidebar.insertBefore(".blog-posts");
          }
          break;
        case "article":
          if (position === "below") {
            return sidebar.insertAfter(".blog-post-wrapper");
          } else {
            return sidebar.insertBefore(".blog-post-wrapper");
          }
      }
    };

    return BlogView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.CartView = (function(superClass) {
    extend(CartView, superClass);

    function CartView() {
      return CartView.__super__.constructor.apply(this, arguments);
    }

    CartView.prototype.events = {
      "click .get-rates": "getRates",
      "change .quantity input": "updateQuantity",
      "click .remove": "removeProduct",
      "click .cart-undo": "undoRemoval",
      "change .cart-instructions textarea": "saveSpecialInstructions"
    };

    CartView.prototype.initialize = function() {
      ;
      this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          "-o-transition": "oTransitionEnd",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
      this.savedProducts = [];
      this.miniCartSavedItems = [];
      ;
      ;
      ;
      Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
      return ;
    };

    CartView.prototype.saveSpecialInstructions = function() {
      var newNote;
      newNote = $(".cart-instructions textarea").val();
      return Shopify.updateCartNote(newNote, function(cart) {});
    };

    ;

    CartView.prototype.updateQuantity = function(e) {
      var newQuantity, productPrice, productRow, variant;
      productRow = $(e.target).parents("tr");
      productPrice = productRow.find("td.total");
      variant = productRow.data("variant");
      newQuantity = $(e.target).val();
      if (newQuantity === "0") {
        this.removeProduct(null, variant);
        return;
      }
      return Shopify.changeItem(variant, newQuantity, (function(_this) {
        return function(cart) {
          var i, item, len, newProductPrice, ref;
          ref = cart.items;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            if (item.id === variant) {
              newProductPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
              productPrice.html("<span class='money'>" + newProductPrice + "</span>");
            }
          }
          _this.updateCart(cart);
          return _this.updateCurrency();
        };
      })(this));
    };

    CartView.prototype.removeProduct = function(e, variant) {
      var imageURL, itemRemoved, itemRow, itemRowContents, productTitle, productURL, undo;
      e.preventDefault();
      if (variant) {
        itemRow = $(".variant-" + variant);
      } else {
        variant = $(e.target).parents("tr").data("variant");
        itemRow = $(e.target).parents("tr");
      }
      itemRowContents = itemRow.find("td");
      productTitle = itemRow.data("title");
      productURL = itemRow.data("url");
      imageURL = itemRow.find("img").attr("src");
      this.savedProducts[variant] = {
        "id": variant,
        "content": itemRowContents,
        "quantity": itemRow.find("td.quantity input").val(),
        "title": productTitle,
        "productURL": productURL,
        "imageURL": imageURL
      };
      itemRemoved = Theme.itemRemovedFromCart.replace("{{ item_title }}", "<a href='" + productURL + "'>" + productTitle + "</a>");
      undo = "<span class='cart-undo' data-variant='" + variant + "'>" + Theme.itemRemovedFromCartUndo + "</span>";
      return Shopify.removeItem(variant, (function(_this) {
        return function(cart) {
          if (Modernizr.csstransitions) {
            itemRow.addClass("removing").one(_this.transitionend, function() {
              itemRow.html("<td class='removed' colspan='4'>" + itemRemoved + " " + undo + "</td>");
              return itemRow.removeClass("removing");
            });
          } else {
            itemRow.html("<td class='removed' colspan='4'>" + itemRemoved + " " + undo + "</td>");
          }
          _this.updateCart(cart);
          return _this.updateCurrency();
        };
      })(this));
    };

    CartView.prototype.undoRemoval = function(e) {
      var savedProduct, variant;
      variant = $(e.target).data("variant");
      savedProduct = this.savedProducts[variant];
      $("tr.variant-" + variant).html(savedProduct.content);
      return Shopify.addItem(variant, savedProduct.quantity, (function(_this) {
        return function() {
          return Shopify.getCart(function(cart) {
            _this.updateCart(cart);
            return _this.updateCurrency();
          });
        };
      })(this));
    };

    CartView.prototype.updateCart = function(cart) {
      var newTotal;
      newTotal = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
      this.$(".cart-totals .cart-price").html("<span class='money'>" + newTotal + "</span>");
      return $(".cart-count").html("<span class='cart-count-text'>" + Theme.cartText + "</span> (<span class='cart-count-number'>" + cart.item_count + "</span>)");
    };

    CartView.prototype.updateCurrency = function() {
      var currencySwitcher, currencyValue;
      currencySwitcher = $('.currency-switcher select');
      currencyValue = currencySwitcher.val();
      return currencySwitcher.val(Theme.currency).trigger("reset-currency").val(currencyValue).trigger("reset-currency");
    };

    ;

    ;

    ;

    CartView.prototype.handleErrors = function(errors) {
      var errorMessage;
      errorMessage = $.parseJSON(errors.responseText);
      errorMessage = Theme.shippingCalcErrorMessage.replace("{{ error_message }}", errorMessage.zip);
      this.$(".cart-shipping-calculator-response").html("<p>" + errorMessage + "</p>");
      return this.$(".get-rates").val(Theme.shippingButton);
    };

    ;

    return CartView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.CollectionView = (function(superClass) {
    extend(CollectionView, superClass);

    function CollectionView() {
      return CollectionView.__super__.constructor.apply(this, arguments);
    }

    CollectionView.prototype.events = {
      "change .collection-tags": "filterCollection",
      "change .collection-sorting select": "sortCollection"
    };

    ;

    ;

    CollectionView.prototype.sortCollection = function(e) {
      var Sorting, currentSearch, i, index, len, part, search, searchParts;
      Sorting = {};
      Sorting.sort_by = this.$(".collection-sorting select").val();
      if ($(e.target).closest(".collection-sorting").hasClass("vendor-collection")) {
        currentSearch = location.search;
        searchParts = currentSearch.split("&");
        for (index = i = 0, len = searchParts.length; i < len; index = ++i) {
          part = searchParts[index];
          if (part.indexOf("sort_by") !== -1) {
            searchParts.splice(index, 1);
          }
        }
        search = searchParts.join("&");
        return location.search = search + "&" + (jQuery.param(Sorting));
      } else {
        return location.search = jQuery.param(Sorting);
      }
    };

    ;

    return CollectionView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ProductListItemView = (function(superClass) {
    extend(ProductListItemView, superClass);

    function ProductListItemView() {
      return ProductListItemView.__super__.constructor.apply(this, arguments);
    }

    ProductListItemView.prototype.events = {
      "click .product-list-item-thumbnail": "redirectToProduct",
      "click .quick-shop-modal-trigger": "initializeQuickShop"
    };

    ProductListItemView.prototype.initialize = function() {
      ;
      this.centerProductItemOverlay();
      return ;
    };

    ;

    ProductListItemView.prototype.centerProductItemOverlay = function() {
      ;
      var trigger, triggerHeight, triggerWidth;
      trigger = this.$(".quick-shop-modal-trigger");
      ;
      triggerHeight = trigger.outerHeight();
      triggerWidth = trigger.outerWidth();
      return trigger.css({
        "marginTop": -(triggerHeight / 2),
        "marginLeft": -(triggerWidth / 2)
      });
    };

    ;

    ProductListItemView.prototype.redirectToProduct = function(e) {
      var url;
      url = !$(e.target).hasClass("quick-shop-modal-trigger") ? $(e.target).data("url") : "";
      if (url) {
        return window.location = url;
      }
    };

    ProductListItemView.prototype.initializeQuickShop = function(e) {
      var quickShopWrapper;
      quickShopWrapper = $(".quick-shop-wrapper");
      quickShopWrapper.data("product-handle", $(e.target).data("product-handle")).data("product-id", $(e.target).data("product-id")).data("variant-id", $(e.target).data("variant-id")).data("vendor-url", $(e.target).data("vendor-url"));
      return new QuickShopView({
        el: quickShopWrapper
      });
    };

    return ProductListItemView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.SlideshowView = (function(superClass) {
    extend(SlideshowView, superClass);

    function SlideshowView() {
      return SlideshowView.__super__.constructor.apply(this, arguments);
    }

    SlideshowView.prototype.initialize = function() {
      ;
      this.slideshowNavigation = false;
      ;
      ;
      this.slideshowPagination = true;
      ;
      ;
      this.slideshowAutoplay = false;
      ;
      $(window).resize((function(_this) {
        return function() {
          return _this.setSlideshowHeight();
        };
      })(this)).trigger("resize");
      return this.slideshowIsSetup = false;
    };

    SlideshowView.prototype.setSlideshowHeight = function() {
      var numSlides, slideshow, slideshowHeight;
      slideshow = this.$(".slideshow-slides");
      slideshowHeight = 1000;
      numSlides = slideshow.find(".slideshow-slide").length;
      return slideshow.imagesLoaded((function(_this) {
        return function() {
          var i, image, imageHeight, index, len, ref, results;
          ref = slideshow.find(".slideshow-slide img");
          results = [];
          for (index = i = 0, len = ref.length; i < len; index = ++i) {
            image = ref[index];
            imageHeight = $(image).height();
            if (imageHeight < slideshowHeight) {
              slideshowHeight = imageHeight;
            }
            if (index === numSlides - 1) {
              _this.$(".slide-image-wrapper").css({
                height: slideshowHeight
              });
              if (!_this.slideshowIsSetup) {
                results.push(_this.setupSlideshow());
              } else {
                results.push(void 0);
              }
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
      })(this));
    };

    SlideshowView.prototype.setupSlideshow = function() {
      this.$(".slideshow-slides").flickity({
        imagesLoaded: true,
        autoPlay: this.slideshowAutoplay,
        prevNextButtons: this.slideshowNavigation,
        pageDots: this.slideshowPagination,
        resize: true,
        wrapAround: true
      });
      return this.slideshowIsSetup = true;
    };

    return SlideshowView;

  })(Backbone.View);

}).call(this);

(function() {
  ;
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.InstagramView = (function(superClass) {
    extend(InstagramView, superClass);

    function InstagramView() {
      return InstagramView.__super__.constructor.apply(this, arguments);
    }

    InstagramView.prototype.events = {};

    InstagramView.prototype.initialize = function() {
      this.photoContainer = this.$(".instagram-photos");
      return this.getInstagramImages();
    };

    InstagramView.prototype.getInstagramImages = function() {
      var count, url;
      if (Theme.twitter) {
        count = 3;
      } else {
        count = 6;
      }
      if (Theme.instagramShowTag && Theme.instagramTag.length) {
        url = "https://api.instagram.com/v1/tags/" + Theme.instagramTag + "/media/recent?access_token=" + Theme.instagramAccessToken + "&count=" + count + "&callback=";
      } else {
        url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + Theme.instagramAccessToken + "&count=" + count + "&callback=";
      }
      return $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: url,
        success: (function(_this) {
          return function(response) {
            var i, len, photo, ref, results;
            if (response.meta.code === 200) {
              ref = response.data;
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                photo = ref[i];
                results.push(_this.photoContainer.append("<a class='instagram-photo' target='_blank' href='" + photo.link + "'><img src='" + photo.images.low_resolution.url + "'/></a>"));
              }
              return results;
            } else {
              _this.$el.remove();
              return console.log("Instagram error: " + response.meta.error_message);
            }
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            _this.$el.remove();
            return console.log("Instagram error: " + response.meta.error_message);
          };
        })(this)
      });
    };

    return InstagramView;

  })(Backbone.View);

  ;

}).call(this);

(function() {
  ;
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.TwitterView = (function(superClass) {
    extend(TwitterView, superClass);

    function TwitterView() {
      return TwitterView.__super__.constructor.apply(this, arguments);
    }

    TwitterView.prototype.events = {};

    TwitterView.prototype.initialize = function() {
      this.fetchTweets();
      ;
      this.window = $(window);
      this.window.load((function(_this) {
        return function() {
          return _this.window.resize(function() {
            return _this.setWidgetHeight();
          }).trigger("resize");
        };
      })(this));
      return ;
    };

    TwitterView.prototype.fetchTweets = function() {
      var config;
      config = {
        "id": Theme.twitterId,
        "maxTweets": 1,
        "enableLinks": true,
        "showUser": true,
        "showTime": true,
        "showRetweet": Theme.twitterShowRetweets,
        "customCallback": this.renderTweets,
        "showInteraction": false
      };
      return twitterFetcher.fetch(config);
    };

    TwitterView.prototype.renderTweets = function(tweets) {
      var i, len, timestamp, tweet;
      if (tweets.length) {
        for (i = 0, len = tweets.length; i < len; i++) {
          tweet = tweets[i];
          tweet = $(tweet);
          this.$(".twitter-tweet").append(tweet);
        }
        timestamp = this.$(".timePosted").text().split(" ");
        return this.$(".timePosted").prepend("<span class='twitter-icon'>&#xE036;</span>");
      } else {
        $(".twitter-widget").remove();
        return console.log("No tweets to display. Most probable cause is an incorrectly entered Widget ID.");
      }
    };

    ;

    TwitterView.prototype.setWidgetHeight = function() {
      var instagramWidget;
      instagramWidget = $(".instagram-widget");
      return instagramWidget.imagesLoaded((function(_this) {
        return function() {
          var instagramHeight, tweet, tweetHeight;
          instagramHeight = instagramWidget.find("img").height();
          tweet = _this.$(".twitter-tweet");
          tweetHeight = tweet.height();
          _this.$el.find(".twitter-tweet-wrapper").height(instagramHeight - 12);
          return tweet.css({
            paddingTop: ((instagramHeight - 12) - tweetHeight) / 2
          });
        };
      })(this));
    };

    ;

    return TwitterView;

  })(Backbone.View);

  ;

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.HomeView = (function(superClass) {
    extend(HomeView, superClass);

    function HomeView() {
      return HomeView.__super__.constructor.apply(this, arguments);
    }

    HomeView.prototype.events = {
      "click .alternative-masonry-feature, .masonry-feature": "redirectMasonryFeatures",
      "click .featured-collection-overlay-wrapper": "redirectFeaturedCollection"
    };

    HomeView.prototype.initialize = function() {
      if (Theme.slideshow) {
        new SlideshowView({
          el: this.$(".home-slideshow")
        });
      }
      if (Theme.instagram) {
        new InstagramView({
          el: this.$(".instagram-widget")
        });
      }
      if (Theme.twitter) {
        new TwitterView({
          el: this.$(".twitter-widget")
        });
      }
      ;
      $(window).resize((function(_this) {
        return function() {
          _this.setupFeaturedCollections();
          if (!Modernizr.csstransforms) {
            return _this.centerFeaturedCollectionText();
          }
        };
      })(this)).trigger("resize");
      ;
      ;
      ;
      $(window).resize((function(_this) {
        return function() {
          return _this.positionMasonryFeatureText();
        };
      })(this)).trigger("resize");
      ;
      ;
      this.masonryFeatures = this.$(".masonry-features");
      $(window).resize((function(_this) {
        return function() {
          if (_this.masonryFeatures.hasClass("has-4-features") || _this.masonryFeatures.hasClass("has-5-features") || _this.masonryFeatures.hasClass("has-6-features")) {
            _this.positionMasonryFeatures();
          }
          if (document.documentElement.offsetWidth > 770 && !_this.masonryFeatures.hasClass("has-1-features")) {
            return _this.setMasonryFeatureHeight();
          }
        };
      })(this)).trigger("resize");
      ;
      ;
    };

    ;

    HomeView.prototype.setupFeaturedCollections = function() {
      var collectionHeight, featuredCollectionImage;
      collectionHeight = 10000;
      featuredCollectionImage = this.$(".featured-collection-image img");
      return this.$(".featured-collections-list").imagesLoaded((function(_this) {
        return function() {
          var collectionImage, i, imageHeight, j, len, len1, results;
          for (i = 0, len = featuredCollectionImage.length; i < len; i++) {
            collectionImage = featuredCollectionImage[i];
            if ($(collectionImage).height() < collectionHeight) {
              collectionHeight = $(collectionImage).height();
            }
          }
          _this.$(".featured-collection-image").height(collectionHeight);
          results = [];
          for (j = 0, len1 = featuredCollectionImage.length; j < len1; j++) {
            collectionImage = featuredCollectionImage[j];
            imageHeight = $(collectionImage).height();
            if (imageHeight > collectionHeight) {
              results.push($(collectionImage).css({
                "marginTop": -(imageHeight - collectionHeight) / 2
              }));
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
      })(this));
    };

    HomeView.prototype.centerFeaturedCollectionText = function() {
      var collectionText, i, len, ref, results, textHeight, textWidth;
      ref = this.$(".featured-collection-overlay");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        collectionText = ref[i];
        collectionText = $(collectionText);
        textHeight = collectionText.height();
        textWidth = collectionText.outerWidth();
        results.push(collectionText.css({
          "marginTop": -(textHeight / 2),
          "marginLeft": -(textWidth / 2)
        }));
      }
      return results;
    };

    HomeView.prototype.redirectFeaturedCollection = function(e) {
      var url;
      url = $(e.target).data("url");
      if (url !== "") {
        return window.location = url;
      }
    };

    ;

    HomeView.prototype.redirectMasonryFeatures = function(e) {
      var url;
      url = $(e.target).closest("article").data("url");
      if (url !== "") {
        return window.location = url;
      }
    };

    ;

    HomeView.prototype.positionMasonryFeatureText = function() {
      var feature, i, len, ref, results, textHeight, textWidth;
      ref = this.$(".masonry-feature-text");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        feature = ref[i];
        feature = $(feature);
        textHeight = feature.height();
        textWidth = feature.outerWidth();
        results.push(feature.css({
          "marginTop": -(textHeight / 2),
          "marginLeft": -(textWidth / 2)
        }));
      }
      return results;
    };

    ;

    ;

    HomeView.prototype.positionMasonryFeatures = function() {
      var bumpFeature, containerWidth, offset;
      if (this.masonryFeatures.hasClass("has-4-features") || this.masonryFeatures.hasClass("has-5-features")) {
        bumpFeature = this.$(".feature-3");
      } else if (this.masonryFeatures.hasClass("has-6-features")) {
        bumpFeature = this.$(".feature-4");
      }
      containerWidth = this.masonryFeatures.outerWidth();
      offset = -(containerWidth * 0.074);
      bumpFeature.css({
        "top": offset
      });
      return this.masonryFeatures.css({
        "marginBottom": offset
      });
    };

    HomeView.prototype.setMasonryFeatureHeight = function() {
      return this.masonryFeatures.imagesLoaded((function(_this) {
        return function() {
          var feature, featureAspect, height, i, image, imageAspect, len, ref, results, width;
          ref = _this.masonryFeatures.children(".masonry-feature");
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            feature = ref[i];
            feature = $(feature);
            height = feature.outerHeight(true);
            width = feature.outerWidth();
            featureAspect = (height / width) * 100;
            feature.children("figure").css({
              "paddingBottom": featureAspect + "%"
            });
            image = feature.find("img");
            image.css({
              "height": "auto",
              "width": "auto"
            });
            imageAspect = (image.height() / image.width()) * 100;
            if (imageAspect < featureAspect) {
              results.push(image.height(feature.children("figure").outerHeight()).css({
                "marginLeft": -((image.width() - width) / 2)
              }));
            } else {
              results.push(image.width(feature.children("figure").outerWidth()).css({
                "marginTop": -((image.height() - height) / 2)
              }));
            }
          }
          return results;
        };
      })(this));
    };

    ;

    ;

    return HomeView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ListCollectionsView = (function(superClass) {
    extend(ListCollectionsView, superClass);

    function ListCollectionsView() {
      return ListCollectionsView.__super__.constructor.apply(this, arguments);
    }

    ListCollectionsView.prototype.events = {};

    ListCollectionsView.prototype.initialize = function() {};

    return ListCollectionsView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.NotFoundView = (function(superClass) {
    extend(NotFoundView, superClass);

    function NotFoundView() {
      return NotFoundView.__super__.constructor.apply(this, arguments);
    }

    NotFoundView.prototype.events = {};

    NotFoundView.prototype.initialize = function() {};

    return NotFoundView;

  })(Backbone.View);

}).call(this);

(function() {
  ;

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ProductSlideshowView = (function(superClass) {
    extend(ProductSlideshowView, superClass);

    function ProductSlideshowView() {
      return ProductSlideshowView.__super__.constructor.apply(this, arguments);
    }

    ProductSlideshowView.prototype.events = {
      "click .product-thumbnails-navigation-previous, .product-thumbnails-navigation-next": "moveProductThumbnails"
    };

    ProductSlideshowView.prototype.initialize = function() {
      this.isQuickShop = this.$el.parent().hasClass("quick-shop");
      this.productThumbnailsWrapper = this.$(".product-thumbnails-wrapper");
      this.productThumbnails = this.$(".product-thumbnails");
      this.productThumbnail = this.$(".product-thumbnail");
      if (this.$(".product-thumbnails").hasClass("has-side-scroll")) {
        this.setupProductSlideshow();
        return $(window).resize((function(_this) {
          return function() {
            _this.setupProductSlideshow();
            return _this.productThumbnails.css({
              "left": 0
            });
          };
        })(this));
      }
    };

    ProductSlideshowView.prototype.setupProductSlideshow = function() {
      var containerWidth, tallestImageHeight;
      tallestImageHeight = 0;
      containerWidth = 0;
      return this.productThumbnails.imagesLoaded((function(_this) {
        return function() {
          var currentImageHeight, currentImageWidth, i, image, len, ref;
          _this.productThumbnailPadding = parseInt(_this.productThumbnail.css("padding-left"), 10) * 2;
          _this.productThumbnail.width((_this.productThumbnailsWrapper.width() / 4) - _this.productThumbnailPadding);
          ref = _this.productThumbnail;
          for (i = 0, len = ref.length; i < len; i++) {
            image = ref[i];
            image = $(image);
            currentImageHeight = image.outerHeight();
            currentImageWidth = image.outerWidth();
            if (currentImageHeight > tallestImageHeight) {
              tallestImageHeight = currentImageHeight;
            }
            containerWidth += currentImageWidth;
          }
          _this.productThumbnailsWrapper.height(tallestImageHeight);
          return _this.productThumbnails.width(containerWidth);
        };
      })(this));
    };

    ProductSlideshowView.prototype.moveProductThumbnails = function(e) {
      var containerWidth, currentPosition;
      containerWidth = this.productThumbnailsWrapper.width();
      currentPosition = this.productThumbnails.position().left;
      if ($(e.currentTarget).hasClass("product-thumbnails-navigation-next") && (currentPosition - containerWidth) > -(this.$(".product-thumbnails").outerWidth())) {
        return this.productThumbnails.css({
          "left": currentPosition - containerWidth
        });
      } else if ($(e.target).hasClass("product-thumbnails-navigation-previous") && currentPosition < 0) {
        return this.productThumbnails.css({
          "left": currentPosition + containerWidth
        });
      }
    };

    return ProductSlideshowView;

  })(Backbone.View);

}).call(this);

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ProductView = (function(superClass) {
    extend(ProductView, superClass);

    function ProductView() {
      this.selectCallback = bind(this.selectCallback, this);
      return ProductView.__super__.constructor.apply(this, arguments);
    }

    ProductView.prototype.events = {
      "click .product-thumbnails img": "swapProductImage",
      "click .add-to-cart input": "addToCart"
    };

    ProductView.prototype.initialize = function() {
      this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          "-o-transition": "oTransitionEnd",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
      this.window = $(window);
      this.isQuickShop = this.$el.hasClass("quick-shop-wrapper");
      this.productId = this.$el.data("product-id");
      this.product = this.isQuickShop ? this.$(".quick-shop").data("item") : window.products[this.productId];
      this.variants = this.product.variants;
      this.images = this.product.images;
      this.minimumPriceArea = this.$(".product-price-minimum");
      this.productImages = this.$el.find(".product-images");
      this.mainImage = this.$(".product-main-image img");
      this.productThumbnail = this.$(".product-thumbnail");
      this.productDetailsWrapper = this.$el.find(".product-details-wrapper");
      this.productDetails = this.$el.find(".product-details");
      this.cacheImages();
      this.setupSelectors();
      ;
      new ProductSlideshowView({
        el: this.productImages
      });
      if (Theme.imageZoom) {
        new ImageZoomView({
          el: this.$(".product-main-image")
        });
      }
      ;
      Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
      return ;
    };

    ;

    ProductView.prototype.cacheImages = function() {
      return Shopify.Image.preload(this.images, "1024x1024");
    };

    ProductView.prototype.setupSelectors = function() {
      var currentLabelWidth, enableHistory, firstVariant, i, index, j, k, label, labelWidth, labels, len, len1, len2, option, optionSelectors, ref, ref1, variant;
      enableHistory = $(document.body).hasClass("template-product") && this.variants.length > 1;
      optionSelectors = new Shopify.OptionSelectors("product-variants-" + this.productId, {
        product: this.product,
        onVariantSelected: this.selectCallback,
        enableHistoryState: enableHistory
      });
      firstVariant = this.isQuickShop ? this.$el.data("variant-id") : FirstVariant[this.productId];
      optionSelectors.selectVariant(firstVariant);
      ;
      if (this.variants.length === 1 && this.variants[0].title === "Default Title" || this.variants[0].title === "Default title") {
        this.$el.find(".product-options").addClass("no-options");
      } else if (this.isQuickShop) {
        this.$(".selector-wrapper label").remove();
        ref = this.product.options;
        for (index = i = 0, len = ref.length; i < len; index = ++i) {
          option = ref[index];
          this.$(".selector-wrapper").eq(index).prepend("<label>" + this.product.options[index].name + "</label>");
        }
      } else if (this.product.options.length === 1 && this.product.options[0] !== "Title") {
        this.$(".selector-wrapper").prepend("<label>" + this.product.options[0] + "</label>");
      }
      ref1 = this.variants;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        variant = ref1[j];
        if (variant.featured_image) {
          this.hasVariantImages = true;
        }
      }
      labels = this.$(".selector-wrapper label");
      labelWidth = 0;
      for (k = 0, len2 = labels.length; k < len2; k++) {
        label = labels[k];
        currentLabelWidth = $(label).width() + 1;
        if (currentLabelWidth > labelWidth) {
          labelWidth = currentLabelWidth;
        }
      }
      return labels.width(labelWidth);
    };

    ProductView.prototype.selectCallback = function(variant, selector) {
      var addToCartButton;
            var addToCartButtonComingSoon;
      addToCartButtonComingSoon = this.$(".add-to-cart input.specialTagClass");
      addToCartButton = this.$(".add-to-cart input");
      this.$(".product-message").empty();
      if (variant) {
        if (variant.available) {
          addToCartButton.val(Theme.addToCartText).removeClass("disabled").prop("disabled", false);
          this.$el.data("variant", variant);
        } else {
          addToCartButton.val(Theme.soldOutText).addClass("disabled").prop("disabled", true);
           addToCartButtonComingSoon.val('Coming Soon').addClass("disabled").prop("disabled", true);
        }
        this.minimumPriceArea.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        this.$(".product-price-compare").remove();
        if (variant.compare_at_price > variant.price) {
          this.minimumPriceArea.after("<span class='product-price-compare money' />");
          this.$(".product-price-compare").html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        }
        if (Theme.currencySwitcher) {
          this.switchCurrency(variant.price, variant.compare_at_price);
        }
        if (this.hasVariantImages) {
            if (variant.featured_image) {
            
         
           var wi = $(window).width();
            
            if(wi >= 771) {
            
            $("body.template-product").animate({ scrollTop: 0 }, "slow");
           
            } else {
              
            $("body.template-product").animate({ scrollTop: $('.product-images.mobileProduct').offset().top }, "slow");

            }
         
            
            
            
            return this.swapProductImage(null, variant.featured_image.src);
            
            
          } else {
            return this.$el.find(".product-main-image img").attr("src", this.product.featured_image);
          }
        }
      } else {
        return addToCartButton.val(Theme.unavailableText).addClass("disabled").prop("disabled", true);
      }
    };

    ProductView.prototype.swapProductImage = function(e, imageSrc) {
      var newImage;
      this.productThumbnail.removeClass("active");
      if (e) {
        this.$(e.currentTarget).parent().addClass("active");
        newImage = this.$(e.currentTarget).data("high-res");
        return this.$(e.currentTarget).closest(this.$el).find(".product-main-image img").attr("src", newImage).trigger("prepare-zoom");
      } else {
        newImage = imageSrc;
        return this.$el.find(".product-main-image img").attr("src", newImage).trigger("prepare-zoom");
      }
    };

    ;

    ;

    ProductView.prototype.addToCart = function(e) {
      var productId;
      e.preventDefault();
      productId = this.$el.data("product-id");
      return Shopify.addItemFromForm("product-form-" + productId, (function(_this) {
        return function(item) {
          var message;
          message = "{{ product }} has been successfully added to your {{ cart_link }}. Feel free to {{ continue_link }} or {{ checkout_link }}.".replace("{{ product }}", "" + _this.product.title).replace("{{ cart_link }}", "<a href='/cart'>cart</a>").replace("{{ continue_link }}", "<a href='/collections/all'>continue shopping</a>").replace("{{ checkout_link }}", "<a href='/checkout'>check out</a>");
          return setTimeout(function() {
            _this.$el.find(".product-message").html(message).addClass("success-message").removeClass("error-message");
            return _this.updateCart(item);
          }, 500);
        };
      })(this));
    };

    ProductView.prototype.updateCart = function(newItem) {
      return Shopify.getCart((function(_this) {
        return function(cart) {
          var alreadyInCart, currencySwitcher, currencyValue, i, item, j, len, len1, miniCartItem, price, ref, ref1, results;
          $(".cart-count").html("<span class='cart-count-text'>" + Theme.cartText + "</span> (<span class='cart-count-number'>" + cart.item_count + "</span>)");
          ref = cart.items;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            alreadyInCart = false;
            ref1 = $(".mini-cart-item");
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              miniCartItem = ref1[j];
              miniCartItem = $(miniCartItem);
              if (miniCartItem.data("variant") === item.variant_id) {
                alreadyInCart = true;
                miniCartItem.find(".mini-cart-item-quantity span").text(item.quantity);
              }
            }
            if (alreadyInCart === false) {
              price = Shopify.formatMoney(item.price, Theme.moneyFormat);
              $(".mini-cart-footer").before("<article class='mini-cart-item' data-variant='" + item.variant_id + "' data-url='" + item.url + "' data-title='" + item.title + "'>\n    <figure class='mini-cart-item-image'>\n        <a href='" + item.url + "'>\n            <img alt='" + item.title + "' src='" + item.image + "'>\n        </a>\n    </figure>\n    <div class='mini-cart-item-details'>\n        <p class='mini-cart-item-quantity'>\n            Qty: <span>" + item.quantity + "</span>\n        </p>\n        <p class='mini-cart-item-title'>\n            <a href='" + item.url + "'>" + item.product_title + " (" + item.variant_title + ")</a>\n        </p>\n        <p class='mini-cart-item-price'>\n            <span class='money'>" + price + "</span>\n        </p>\n    </div>\n</article>");
              currencySwitcher = $('.currency-switcher select');
              currencyValue = currencySwitcher.val();
              results.push(currencySwitcher.val(Theme.currency).trigger("reset-currency").val(currencyValue).trigger("reset-currency"));
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
      })(this));
    };

    ProductView.prototype.handleErrors = function(error) {
      var max, message, target, variant, variantID;
      if (error.responseJSON.message === "Cart Error") {
        variantID = parseInt(this.$el.find("#product-variants-" + this.productId).val(), 10);
        target = (function() {
          var i, len, ref, results;
          ref = this.product.variants;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            variant = ref[i];
            if (variant.id === variantID) {
              results.push(variant);
            }
          }
          return results;
        }).call(this);
        max = target[0].inventory_quantity;
        message = "Unable to add more than {{ stock }} to your cart.".replace("{{ stock }}", max);
      } else {
        message = "We were unable to add this product to your cart. Please try again later. Contact us if you continue to have issues.";
      }
      return setTimeout((function(_this) {
        return function() {
          return _this.$el.find(".product-message").html(message).addClass("error-message").removeClass("success-message");
        };
      })(this), 1000);
    };

    ;

    return ProductView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.QuickShopView = (function(superClass) {
    extend(QuickShopView, superClass);

    function QuickShopView() {
      return QuickShopView.__super__.constructor.apply(this, arguments);
    }

    QuickShopView.prototype.events = {
      "click": "closeQuickShop"
    };

    QuickShopView.prototype.initialize = function() {
      this.productImages = this.$(".product-images");
      this.mainImage = this.$(".product-main-image");
      this.thumbnailsOuterWrapper = this.$(".product-thumbnails-outer-wrapper");
      this.thumbnailsWrapper = this.thumbnailsOuterWrapper.find(".product-thumbnails-wrapper");
      this.thumbnails = this.$(".product-thumbnails");
      this.productDetails = this.$(".product-details");
      this.quickShop = this.$(".quick-shop");
      Shopify.getProduct(this.$el.data("product-handle"), (function(_this) {
        return function(item) {
          var i, j, len, len1, ref, ref1, results, rte, select;
          $(document.body).addClass("scroll-locked");
          _this.quickShop.data("item", item);
          _this.$el.addClass("visible");
          _this.setupProductDetails(item);
          new ProductView({
            el: _this.$el
          });
          ref = _this.$("select");
          for (i = 0, len = ref.length; i < len; i++) {
            select = ref[i];
            new SelectView({
              el: select
            });
          }
          ref1 = _this.$(".rte");
          results = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            rte = ref1[j];
            results.push(new RTEView({
              el: rte
            }));
          }
          return results;
        };
      })(this));
      return $(window).resize((function(_this) {
        return function() {
          _this.positionQuickShop();
          if (!theme.ltIE9) {
            if (document.documentElement.offsetWidth <= 1020 && $(document.body).hasClass("quick-shop-open")) {
              return _this.closeQuickShop();
            }
          }
        };
      })(this));
    };

    QuickShopView.prototype.closeQuickShop = function(e) {
      if (!this.$(e.target).closest(".quick-shop").length) {
        return this.$el.removeClass("visible").one("trend", (function(_this) {
          return function() {
            $(document.body).removeClass("scroll-locked");
            _this.$el.add(_this.quickShop).removeClass("active");
            _this.mainImage.add(_this.thumbnails).add(_this.productDetails).empty();
            _this.thumbnailsWrapper.add(_this.thumbnails).removeAttr("style");
            _this.thumbnails.removeClass("has-side-scroll");
            return _this.$(".product-thumbnails-navigation").remove();
          };
        })(this));
      }
    };

    QuickShopView.prototype.setupProductDetails = function(item) {
      var addToCartButton, compactImage, description, firstVariant, hasVariantImages, i, image, index, itemCompareAtPrice, itemPrice, j, k, largeImage, len, len1, len2, ref, ref1, ref2, stock, variant, variantPrice, vendor, vendorURL, zoom;
      if (item.images.length > 4) {
        this.thumbnails.addClass("has-side-scroll");
      }
      ref = item.images;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        image = ref[index];
        largeImage = Shopify.resizeImage(image, "1024x1024");
        compactImage = Shopify.resizeImage(image, "compact");
        if (item.images.length > 1) {
          this.thumbnails.append("<span class=\"product-thumbnail\" data-image-position=\"" + index + "\">\n    <img data-high-res=\"" + largeImage + "\" src=\"" + compactImage + "\">\n</span>");
        }
      }
      if (item.images.length > 4) {
        this.thumbnailsOuterWrapper.prepend("<span class=\"product-thumbnails-navigation product-thumbnails-navigation-previous\">&#xe601;</span>");
        this.thumbnailsOuterWrapper.append("<span class=\"product-thumbnails-navigation product-thumbnails-navigation-next\">&#xe600;</span>");
      }
      zoom = "";
      ;
      hasVariantImages = false;
      ref1 = item.variants;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        variant = ref1[j];
        if (variant.id === $(".quick-shop-wrapper").data("variant-id") && variant.featured_image) {
          hasVariantImages = true;
        }
      }
      if (hasVariantImages) {
        largeImage = Shopify.resizeImage(variant.featured_image, "1024x1024");
      } else {
        largeImage = Shopify.resizeImage(item.featured_image, "1024x1024");
      }
      this.mainImage.prepend("<img class=\"product-image\" src=\"" + largeImage + "\">\n" + zoom);
      vendor = "";
      ;
      firstVariant = item.variants[0];
      itemPrice = Shopify.formatMoney(firstVariant.price, Theme.moneyFormat);
      itemCompareAtPrice = "";
      if (firstVariant.compare_at_price > firstVariant.price) {
        itemCompareAtPrice = Shopify.formatMoney(firstVariant.compare_at_price, Theme.moneyFormat);
      }
      stock = "InStock";
      addToCartButton = "<input type='submit' value='Add to cart' />";
      if (!item.available) {
        stock = "OutOfStock";
        addToCartButton = "<input type='submit' class='disabled' disabled='disabled' value='Sold out' />";
      }
      description = "";
      if (item.description !== null) {
        description = "<div class='product-description rte' itemprop='description'>" + item.description + "</div>";
      }
      this.productDetails.append(vendor + "\n\n<h1 class=\"product-title\">" + item.title + "</h1>\n\n<p class=\"product-price\" itemprop=\"offers\" itemscope itemtype=\"http://schema.org/Offer\">\n    <span class=\"product-price-minimum money\">" + itemPrice + "</span>\n    <span class=\"product-price-compare money\">" + itemCompareAtPrice + "</span>\n    <link itemprop=\"availability\" href=\"http://schema.org/" + stock + "\">USD\n</p>\n\n<form action=\"/cart/add\" method=\"post\" id=\"product-form-" + item.id + "\" data-product-id=\"" + item.id + "\">\n\n    <div class=\"product-options\">\n        <select class=\"product-variants\" name=\"id\" id=\"product-variants-" + item.id + "\"></select>\n    </div>\n\n    <div class=\"product-quantity inline-input-wrapper\">\n        <label>Quantity</label>\n        <input type=\"text\" name=\"quantity\" value=\"1\" />\n    </div>\n\n    <div class=\"add-to-cart\">\n        " + addToCartButton + "\n    </div>\n\n    <div class=\"product-message\"></div>\n\n</form>\n\n" + description + "\n\n<a class=\"view-product\" href=\"" + item.url + "\">View product</a>");
      ref2 = item.variants;
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        variant = ref2[k];
        variantPrice = Shopify.formatMoney(variant.price, Theme.moneyFormat);
        this.$(".product-variants").append("<option value='" + variant.id + "'>" + variant.title + " - " + variantPrice + "</option>");
      }
      return this.productImages.imagesLoaded((function(_this) {
        return function() {
          _this.quickShop.addClass("active");
          return _this.positionQuickShop();
        };
      })(this));
    };

    QuickShopView.prototype.positionQuickShop = function() {
      return this.quickShop.css({
        marginTop: -(this.quickShop.outerHeight() / 2),
        marginLeft: -(this.quickShop.outerWidth() / 2)
      });
    };

    return QuickShopView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.RTEView = (function(superClass) {
    extend(RTEView, superClass);

    function RTEView() {
      return RTEView.__super__.constructor.apply(this, arguments);
    }

    RTEView.prototype.events = {
      "click .tabs li": "switchTabs"
    };

    RTEView.prototype.initialize = function() {
      this.setupTabs();
      return this.resizeVideos();
    };

    RTEView.prototype.switchTabs = function(e) {
      var content, position, tab, tabContainer, tabContentContainer;
      e.preventDefault();
      tab = $(e.currentTarget);
      tabContainer = tab.parent();
      tabContentContainer = tabContainer.next();
      position = tab.index();
      content = tabContentContainer.find("> li").eq(position);
      tabContainer.find("> li").removeClass("active");
      tabContentContainer.find("> li").removeClass("active");
      tab.addClass("active");
      return content.addClass("active");
    };

    RTEView.prototype.setupTabs = function() {
      var tabs;
      tabs = this.$el.find(".tabs");
      tabs.find("li:first").addClass("active");
      return tabs.next().find("li:first").addClass("active");
    };

    RTEView.prototype.resizeVideos = function() {
      var i, len, ref, results, video;
      this.$el.fitVids({
        customSelector: "iframe"
      });
      ref = this.$("iframe");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        video = ref[i];
        video = $(video);
        if (video.hasClass("highlight")) {
          results.push(video.parent().addClass("highlight"));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return RTEView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.SelectView = (function(superClass) {
    extend(SelectView, superClass);

    function SelectView() {
      return SelectView.__super__.constructor.apply(this, arguments);
    }

    SelectView.prototype.events = {
      "change": "updateSelectText"
    };

    SelectView.prototype.initialize = function() {
      if (!(this.$el.parent(".select-wrapper").length || this.$el.hasClass("product-variants"))) {
        this.$el.wrap("<div class='select-wrapper' />").parent().prepend("<span class='selected-text'></span>");
      }
      return this.updateSelectText();
    };

    SelectView.prototype.updateSelectText = function() {
      var newOption;
      newOption = this.$el.find("option:selected").text();
      return this.$el.siblings(".selected-text").text(newOption);
    };

    return SelectView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ThemeView = (function(superClass) {
    extend(ThemeView, superClass);

    function ThemeView() {
      return ThemeView.__super__.constructor.apply(this, arguments);
    }

    ThemeView.prototype.el = document.body;

    ThemeView.prototype.initialize = function() {
      var body;
      body = $(document.body);
      this.ltIE9 = $("html").hasClass("lt-ie9");
      this.isHome = body.hasClass("template-index");
      this.isCollection = body.hasClass("template-collection");
      this.isListCollections = body.hasClass("template-list-collections");
      this.isProduct = body.hasClass("template-product");
      this.isCart = body.hasClass("template-cart");
      this.isPage = body.hasClass("template-page");
      this.isBlog = body.hasClass("template-blog") || body.hasClass("template-article");
      this.isAccount = body.attr("class").indexOf("-customers-") > 0;
      this.is404 = body.hasClass("template-404");
      this.isSearch = body.hasClass("template-search");
      if (navigator.userAgent.indexOf("MSIE 10") !== -1) {
        this.$el.addClass("ie10");
      }
      return $(window).load((function(_this) {
        return function() {
          return body.removeClass("loading");
        };
      })(this));
    };

    ThemeView.prototype.render = function() {
      var i, j, k, len, len1, len2, productItem, ref, ref1, ref2, rte, select;
      new HeaderView({
        el: $(".main-header")
      });
      new NavigationView({
        el: $(".navigation")
      });
      new FooterView({
        el: $("footer")
      });
      if (Theme.currencySwitcher) {
        new CurrencyView({
          el: this.$(".currency-switcher")
        });
      }
      if (this.isHome) {
        new HomeView({
          el: this.$el
        });
        if (Theme.quickShop && Theme.featuredProducts) {
          new QuickShopView({
            el: this.$(".featured-products")
          });
        }
      }
      if (this.isCollection) {
        new CollectionView({
          el: this.$("#collectionHeader")
        });
        if (Theme.quickShop) {
          new QuickShopView({
            el: this.$(".collection-products")
          });
        }
      }
      if (this.isListCollections) {
        new ListCollectionsView({
          el: $(".collections-list")
        });
      }
      if (this.isProduct) {
        new ProductView({
          el: this.$(".product-wrap")
        });
        if (Theme.quickShop && Theme.relatedProducts) {
          new QuickShopView({
            el: this.$(".related-products")
          });
        }
      }
      if (this.isCart) {
        new CartView({
          el: this.$el
        });
      }
      if (this.isBlog) {
        new BlogView({
          el: this.$el
        });
      }
      if (this.isAccount) {
        new AccountView({
          el: this.$el
        });
      }
      if (this.is404) {
        new NotFoundView({
          el: this.$el
        });
      }
      if (this.isSearch && Theme.quickShop) {
        new QuickShopView({
          el: this.$(".search-results-products")
        });
      }
      ref = $(".rte");
      for (i = 0, len = ref.length; i < len; i++) {
        rte = ref[i];
        new RTEView({
          el: rte
        });
      }
      ref1 = $("select");
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        select = ref1[j];
        new SelectView({
          el: select
        });
      }
      ref2 = $(".product-list-item");
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        productItem = ref2[k];
        new ProductListItemView({
          el: productItem
        });
      }
      if ($("html").hasClass("lt-ie10")) {
        return this.inputPlaceholderFix();
      }
    };

    ThemeView.prototype.inputPlaceholderFix = function() {
      var i, input, len, placeholders, text;
      placeholders = $("[placeholder]");
      for (i = 0, len = placeholders.length; i < len; i++) {
        input = placeholders[i];
        input = $(input);
        if (!(input.val().length > 0)) {
          text = input.attr("placeholder");
          input.attr("value", text);
          input.data("original-text", text);
        }
      }
      placeholders.focus(function() {
        input = $(this);
        if (input.val() === input.data("original-text")) {
          return input.val('');
        }
      });
      return placeholders.blur(function() {
        input = $(this);
        if (input.val().length === 0) {
          return input.val(input.data("original-text"));
        }
      });
    };

    return ThemeView;

  })(Backbone.View);

  $(function() {
    window.theme = new ThemeView();
    return theme.render();
  });

}).call(this);


/* CUSTOM */


$(window).ready(function() {
    
 var wi = $(window).width();
// var he = $(window).height();
 
 // if (wi >=1021 && he >=1200) {
 if (wi >=1025) {

$(function(){ // document ready
   if ($('body.template-product .product-details-wrapper').length) { // make sure "#sticky" element exists
      var el = $('body.template-product .product-details-wrapper');
      var stickyTop = $('body.template-product .product-details-wrapper').offset().top - 50; // returns number, change this number and the other negative value to put more space before the footer overlaps
      var stickyHeight = $('body.template-product .product-details-wrapper').height();

      $(window).scroll(function(){ // scroll event '#shopify-product-reviews' instead of footer
          var limit = $('.yotpo.yotpo-main-widget').offset().top - stickyHeight - 770; //number from bottom, touching top also affects

          var windowTop = $(window).scrollTop(); // returns number

          if (stickyTop < windowTop){
            el.css({ position: 'fixed', top: 66, display: 'inline' });
            $('body.template-product .product-details-wrapper').css('max-width','554.391px');
            $('body.template-product .related-products-wrapper').css('max-width','151.188px');

          }
          else {
             el.css('position','static');
             $('body.template-product .related-products-wrapper').css('max-width','151.188px');

          }

          if (limit < windowTop) {
          var diff = limit - windowTop;
          el.css({top: diff});
          }
        });
   }
});

$(function(){ // document ready
   if ($('body.template-product .related-products-wrapper').length) { // make sure "#sticky" element exists
      var el = $('body.template-product .related-products-wrapper');
      var stickyTop = $('body.template-product .related-products-wrapper').offset().top - 80; // returns number
      var stickyHeight = $('body.template-product .related-products-wrapper').height();

      $(window).scroll(function(){ // scroll event '#shopify-product-reviews' instead of footer
          var limit = $('.yotpo.yotpo-main-widget').offset().top - stickyHeight - 770;

          var windowTop = $(window).scrollTop(); // returns number

          if (stickyTop < windowTop){
            el.css({ position: 'fixed', top: 66 });
            $('.has-related-products-right .related-products-wrapper').css('margin-top','0');
          }
          else {
             el.css('position','static');
             $('.has-related-products-right .related-products-wrapper').css('margin-top','35px');

          }

          if (limit < windowTop) {
          var diff = limit - windowTop;
          el.css({top: diff});
          }
        });
   }
});

  }
  
        

 
  if (wi <= 770 ) {
     

    $( "div.product-images" ).replaceWith( $( ".mobileProduct" ) );
    
     $( "div.product-images" ).css('display','none');
      
    $( ".mobileProduct" ).css('display','initial');
    
    
    $( ".product-details-wrapper").prependTo ( $( ".main-product-wrap.product-wrap" ) );
    
    
    
  }
      
      
    
  
  });

$(window).resize(function() {
    
 var wi = $(window).width();
 //var he = $(window).height();
 
  //if (wi >=1021 && he >=1200) {

if (wi >=1025) {
  
  
  
$(function(){ // document ready
   if ($('body.template-product .product-details-wrapper').length) { // make sure "#sticky" element exists
      var el = $('body.template-product .product-details-wrapper');
      var stickyTop = $('body.template-product .product-details-wrapper').offset().top - 50; // returns number
      var stickyHeight = $('body.template-product .product-details-wrapper').height();

      $(window).scroll(function(){ // scroll event
          var limit = $('body.template-product footer').offset().top - stickyHeight - 770; //number from bottom, touching top also affects

          var windowTop = $(window).scrollTop(); // returns number

          if (stickyTop < windowTop){
            el.css({ position: 'fixed', top: 66, display: 'inline' });
            $('body.template-product .product-details-wrapper').css('max-width','554.391px');
            $('body.template-product .related-products-wrapper').css('max-width','151.188px');

          }
          else {
             el.css('position','static');
             $('body.template-product .related-products-wrapper').css('max-width','151.188px');

          }

          if (limit < windowTop) {
          var diff = limit - windowTop;
          el.css({top: diff});
          }
        });
   }
});

$(function(){ // document ready
   if ($('body.template-product .related-products-wrapper').length) { // make sure "#sticky" element exists
      var el = $('body.template-product .related-products-wrapper');
      var stickyTop = $('body.template-product .related-products-wrapper').offset().top - 80 // returns number
      var stickyHeight = $('body.template-product .related-products-wrapper').height();

      $(window).scroll(function(){ // scroll event
          var limit = $('body.template-product footer').offset().top - stickyHeight - 770;

          var windowTop = $(window).scrollTop(); // returns number

          if (stickyTop < windowTop){
            el.css({ position: 'fixed', top: 66 });
           
          }
          else {
             el.css('position','static');
          }

          if (limit < windowTop) {
          var diff = limit - windowTop;
          el.css({top: diff});
          }
        });
   }
});

  }
    
    
      if (wi <= 770 ) {
     

    $( "div.product-images" ).replaceWith( $( ".mobileProduct" ) );
    
     $( "div.product-images" ).css('display','none');
      
    $( ".mobileProduct" ).css('display','initial');
    
        $( ".product-details-wrapper").prependTo ( $( ".main-product-wrap.product-wrap" ) );

    
      } else {
        
         $( ".mobileProduct" ).css('display','none');
    
        $( "#customImages" ).css('display','initial');

         $( ".product-details-wrapper").appendTo ( $( ".main-product-wrap.product-wrap" ) );

        
        
      }
    
    
    });


$( document ).ready(function() {
  
  $('close-thin').trigger('close');
  
  $( '#size-chart-trigger' ).insertAfter('div.add-to-cart');
  
  $( 'div.spr-summary' ).insertAfter('p.product-price');
  
    
  $("a.spr-summary-actions-newreview").click(function() {
  $("html, body").animate({ scrollTop: $('#shopify-product-reviews').offset().top }, 1250);
  return false;
  });
  
  $('#searchIcon').click(function(e) {
    $('#searchPop').lightbox_me({
        centered: true,
      overlayCSS:	{background: 'black', opacity: .8},
        });
    e.preventDefault();
});
  
   $('#contentCareLink').click(function(e) {
    $('#contentCare').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},

        });
    e.preventDefault();
});
  
  //Media Mentions
  
    $('#mediaDaySpaLink').click(function(e) {
    $('#mediaDaySpa').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},

        });
    e.preventDefault();
});
  
      $('#mediaAmericanSpaLink').click(function(e) {
    $('#mediaAmericanSpa').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},

        });
    e.preventDefault();
});
  
  $('#mediaBeautyBizLink').click(function(e) {
    $('#mediaBeautyBiz').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},

        });
    e.preventDefault();
});
  

    $('#mediaProfitsLink').click(function(e) {
    $('#mediaProfits').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},

        });
    e.preventDefault();
});
  
      $('#mediaSpaBusinessLink').click(function(e) {
    $('#mediaSpaBusiness').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},

        });
    e.preventDefault();
});
  
  
  
  
  
  
    $("#lightboxVid1").click(function(e) {
    $('#iframeVid1').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},
        onLoad: function() {

          var original = "https://www.youtube.com/embed/ah2R8JLWAI8?modestbranding=1&autohide=1&showinfo=0&controls=1";
          var autoplay = "&autoplay=1";
        $("#iframeVid1").attr('src',original + autoplay);   
        },   
        onClose: function() {
          $("#iframeVid1").attr('src','');  
        },
        });
    	e.preventDefault();

});
  
$("#lightboxVid2").click(function(e) {
    $('#iframeVid2').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},
        onLoad: function() {

          var original = "https://www.youtube.com/embed/QazOyBUaBdI?modestbranding=1&autohide=1&showinfo=0&controls=1";
          var autoplay = "&autoplay=1";
        $("#iframeVid2").attr('src',original + autoplay);   
        },   
        onClose: function() {
          $("#iframeVid2").attr('src','');  
        },
        });
    	e.preventDefault();

});

$("#lightboxVid3").click(function(e) {
    $('#iframeVid3').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},
        onLoad: function() {

          var original = "";
          var autoplay = "&autoplay=1";
        $("#iframeVid3").attr('src',original + autoplay);   
        },   
        onClose: function() {
          $("#iframeVid3").attr('src','');  
        },
        });
    	e.preventDefault();

});
  
$("#lightboxVid4").click(function(e) {
    $('#iframeVid4').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},
        onLoad: function() {

          var original = "";
          var autoplay = "&autoplay=1";
        $("#iframeVid4").attr('src',original + autoplay);   
        },   
        onClose: function() {
          $("#iframeVid4").attr('src','');  
        },
        });
    	e.preventDefault();

}); 
  
$("#lightboxVid5").click(function(e) {
    $('#iframeVid5').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},
        onLoad: function() {

          var original = "";
          var autoplay = "&autoplay=1";
        $("#iframeVid5").attr('src',original + autoplay);   
        },   
        onClose: function() {
          $("#iframeVid5").attr('src','');  
        },
        });
    	e.preventDefault();

});   
  
$("#lightboxVid6").click(function(e) {
    $('#iframeVid6').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},
        onLoad: function() {

          var original = "";
          var autoplay = "&autoplay=1";
        $("#iframeVid6").attr('src',original + autoplay);   
        },   
        onClose: function() {
          $("#iframeVid6").attr('src','');  
        },
        });
    	e.preventDefault();

}); 
  
  
  
  
  
  
  $("a#reviewsLink").click(function() {
  $("html, body").animate({ scrollTop: $('#shopify-product-reviews').offset().top }, 1250);
  return false;
  });

  $('a#tcLink').click(function(e) {
    $('div#tcText').lightbox_me({
        centered: true,
            overlayCSS:	{background: 'black', opacity: .8},

        });
    e.preventDefault();
});

  


  
});


 $(document).ready(function() {

 
    var text = $('h3.slide-title').text();
    var sentences = text.split(' ');
  
   var one = sentences[0];
   var two = sentences[1];
   var three = sentences[2];
   var four = sentences[3];

   
   
    $(one).css('display','none');

  });   
  
  
  
 $(document).ready(function() {
   
         
   
   $("div.row-content:first-child").show();
   
 

	$( "#fabricsMenu li a" ).on('click touchstart', function () {

      $("div.row-content").hide();
      $("img.aboutBanner").hide();
      
  var targetDiv = $(this).attr('rel');
  $("div#"+targetDiv).show();
      
  $("img#"+targetDiv).show();

           $( "#fabricsMenu ul li a" ).css('color','#000');
  $(this).css('color','#BDBDBD');

      
      
      
      
      
      

});
   

 
});


// close X on all pages browsers
$(document).ready(function() { 
$('.close-thin').click(function(e) {
      $('.close-thin').trigger('close');
      e.preventDefault();
});
   });


// megaNav Image Fix

//Men
$(document).ready(function() { 
  
  
	$('nav ul#customNav >  li:nth-child(11)').mouseover(function() {

      $("figure.mega-nav-image img").attr( "src", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default-2.jpg?v=46698295447941407871462130038" );
      $("figure.mega-nav-image img").attr( "data-image", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default-2.jpg?v=46698295447941407871462130038" );

    
    })
      
      
      
});
  
  
  
  // Women
  $(document).ready(function() { 
    
    
	$('nav ul#customNav >  li:nth-child(6)').mouseover(function(e) {
      e.preventDefault();

      $("figure.mega-nav-image img").attr( "src", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default.jpg?v=46698295447941407871462130038" );
      $("figure.mega-nav-image img").attr( "data-image", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default.jpg?v=46698295447941407871462130038" );

    
    })
      

      
});

      // Mani & Pedi
  $(document).ready(function() { 
    
    
	$('nav ul#customNav >  li:nth-child(20)').mouseover(function(e) {
      e.preventDefault();

      $("figure.mega-nav-image img").attr( "src", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default-3.jpg?v=46698295447941407871462130038" );
      $("figure.mega-nav-image img").attr( "data-image", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default-3.jpg?v=46698295447941407871462130038" );

    
    })
      

      
});

      // Industries
  $(document).ready(function() { 
    
    
	$('nav ul#customNav >  li:nth-child(25)').mouseover(function(e) {
      e.preventDefault();

      $("figure.mega-nav-image img").attr( "src", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default-4.jpg?v=46698295447941407871462130038" );
      $("figure.mega-nav-image img").attr( "data-image", "//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/mega-nav-image-default-4.jpg?v=46698295447941407871462130038" );

    
    })
      

      
});


    // Fix Mobile About Us Menu
    
      $(document).ready(function() { 

    $('#fabricsMenu select').change(function () {
      
        if ($('#fabricsMenu select option:selected').text() == 'The Company'){
		$("div#item1").show();
 		$("img#item1").show();
    
        $("div#item2").hide();
 		$("img#item2").hide();
          
        $("div#item3").hide();
 		$("img#item3").hide();
          
        $("div#item4").hide();
 		$("img#item4").hide();
          
        $("div#item5").hide();
 		$("img#item5").hide();
          
        $("div#item6").hide();
 		$("img#item6").hide();
          
        $("div#item7").hide();
 		$("img#item7").hide();
      
              $(".aboutDrop").css('border-color','#000');

      
          
        }
        else if ($('#fabricsMenu select option:selected').text() == 'Noel Asmar'){
        
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").show();
 		 $("img#item2").show();
          
        $("div#item3").hide();
 		$("img#item3").hide();
          
        $("div#item4").hide();
 		$("img#item4").hide();
          
        $("div#item5").hide();
 		$("img#item5").hide();
          
        $("div#item6").hide();
 		$("img#item6").hide();
          
        $("div#item7").hide();
 		$("img#item7").hide();
        
        $(".aboutDrop").css('border-color','#fff');
          
          
        }
        else if ($('#fabricsMenu select option:selected').text() == 'The Team'){
     
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").show();
 		$("img#item3").show();
          
        $("div#item4").hide();
 		$("img#item4").hide();
          
        $("div#item5").hide();
 		$("img#item5").hide();
          
        $("div#item6").hide();
 		$("img#item6").hide();
          
        $("div#item7").hide();
 		$("img#item7").hide();

                  $(".aboutDrop").css('border-color','#000');

    
        } 
        else if ($('#fabricsMenu select option:selected').text() == 'Accolades'){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").show();
 		 $("img#item4").show();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").hide();
 		 $("img#item7").hide();
  
                $(".aboutDrop").css('border-color','#000');


        }
        else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").show();
 		 $("img#item5").show();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").hide();
 		 $("img#item7").hide();
              $(".aboutDrop").css('border-color','#000');

 
        }
         else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").show();
 		 $("img#item6").show();
          
         $("div#item7").hide();
 		 $("img#item7").hide();
              $(".aboutDrop").css('border-color','#000');


        }
        else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").show();
 		 $("img#item7").show();
              $(".aboutDrop").css('border-color','#000');

 
        }
        
         if ($('#fabricsMenu select option:selected').text() == 'Performance'){
		$("div#item1").show();
 		$("img#item1").show();
    
        $("div#item2").hide();
 		$("img#item2").hide();
          
        $("div#item3").hide();
 		$("img#item3").hide();
          
        $("div#item4").hide();
 		$("img#item4").hide();
          
        $("div#item5").hide();
 		$("img#item5").hide();
          
        $("div#item6").hide();
 		$("img#item6").hide();
          
        $("div#item7").hide();
 		$("img#item7").hide();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
          
        }
        else if ($('#fabricsMenu select option:selected').text() == 'Signature'){
        
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").show();
 		 $("img#item2").show();
          
        $("div#item3").hide();
 		$("img#item3").hide();
          
        $("div#item4").hide();
 		$("img#item4").hide();
          
        $("div#item5").hide();
 		$("img#item5").hide();
          
        $("div#item6").hide();
 		$("img#item6").hide();
          
        $("div#item7").hide();
 		$("img#item7").hide();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
          
          
        }
        else if ($('#fabricsMenu select option:selected').text() == 'Compression'){
     
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").show();
 		$("img#item3").show();
          
        $("div#item4").hide();
 		$("img#item4").hide();
          
        $("div#item5").hide();
 		$("img#item5").hide();
          
        $("div#item6").hide();
 		$("img#item6").hide();
          
        $("div#item7").hide();
 		$("img#item7").hide();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
        } 
        else if ($('#fabricsMenu select option:selected').text() == 'Impression'){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").show();
 		 $("img#item4").show();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").hide();
 		 $("img#item7").hide();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
        }
        else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").show();
 		 $("img#item5").show();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").hide();
 		 $("img#item7").hide();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
        }
         else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").show();
 		 $("img#item6").show();
          
         $("div#item7").hide();
 		 $("img#item7").hide();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
        }
        else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").show();
 		 $("img#item7").show();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
        }
                else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").hide();
 		 $("img#item7").hide();

   	     $("div#item8").show();
 		 $("img#item8").show();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").hide();
 		 $("img#item10").hide();
        }
         else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").hide();
 		 $("img#item7").hide();

   	     $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").show();
 		 $("img#item9").show();

    	 $("div#item10").hide();
 		 $("img#item10").hide();

        }
         else if ($('#fabricsMenu select option:selected').text() == ''){
  
         $("div#item1").hide();
 		 $("img#item1").hide();
         
         $("div#item2").hide();
 		 $("img#item2").hide();
          
         $("div#item3").hide();
 		 $("img#item3").hide();
          
         $("div#item4").hide();
 		 $("img#item4").hide();
          
         $("div#item5").hide();
 		 $("img#item5").hide();
          
         $("div#item6").hide();
 		 $("img#item6").hide();
          
         $("div#item7").hide();
 		 $("img#item7").hide();

    	 $("div#item8").hide();
 		 $("img#item8").hide();

  	     $("div#item9").hide();
 		 $("img#item9").hide();

    	 $("div#item10").show();
 		 $("img#item10").show();
        }
    }); 

$('#fabricsMenu select option').each(function () {
  
if ($(this).length == 0) {
  
  $(this).remove();
  
}


});

});
        
$(window).scroll(function() {  
  
   var wi = $(window).width();
  
  if (wi < 541) {
  
    var scroll = $(window).scrollTop();

    if (scroll >= 367) {
        $("div#white").addClass("sticky");
      $('#fabricsPage #fabricsMenu').css('border-bottom','1px solid #000');
      
    } else {
        $("div#white").removeClass("sticky");
            $('#fabricsPage #fabricsMenu').css('border-bottom','none');

      
      
    }
  }  else if (wi < 771 && wi > 540) {
  
    var scroll = $(document).scrollTop();

    if (scroll >= 631) {
        $("div#white").addClass("sticky");
            $('#fabricsPage #fabricsMenu').css('border-bottom','1px solid #000');

      
      
    } else {
        $("div#white").removeClass("sticky");
            $('#fabricsPage #fabricsMenu').css('border-bottom','none');

      
      
      
    }
  } 

 }); 


$(window).resize(function() {  
var wi = $(window).width();
  
  if (wi > 771) {
  
  $("div#white").removeClass("sticky");
          $('#fabricsPage #fabricsMenu').css('border-bottom','none');

    
    
  
  }
  
  }); 

$(window).load(function() {  
  
  var wi = $(window).width();
  
  if (wi < 541) {
    
    
   $('<div id="boxOneInsideRight"></div>').insertAfter('div#boxTwo #boxOneInsideLeft');
  
    $('<div id="youKnow" class="clear"></div>').insertAfter('.row-content div#left');

     //$('#Image').prependTo('#fabricsActive');
       // $('#item1').show();

    
    
    
  }
  
  
  }); 

$(window).resize(function() {  
  
  var wi = $(window).width();
  
  if (wi < 541) {
    
    $('#youKnow').addClass('clear');
    
    // $('#Image').prependTo('#fabricsActive');

    
    
  
  } else {
    
    $('#youKnow').removeClass('clear');
 
      //   $('#Image').appendTo('#fabricsActive');

    
  }
  
  
  }); 

$(document).ready(function() {  

  
  $('.breadcrumbs a:contains("Collections")').css('display','none');
  
  $('.breadcrumbs a:contains("Collections") + span.divider').css('display','none');

  

  }); 

//Collection Banner Images - New Number Updates


  
$(window).load(function() {  
  
  var wi = $(window).width();

    
  var collection = $('.breadcrumbs span:last-child').text();

  collection = collection.replace(/\s+/g, '_');
  collection = collection.replace('&','');
  collection = collection.replace('__','_');

  
  if (wi < 541) {
    
    $('#collectionWideImage.realCollection').attr("src","https://cdn.shopify.com/s/files/1/0878/1816/files/NAU_" + collection + "_Mobile.jpg?13282905410271515286");
    
  } else if (wi < 1021) {
    
    
   $('#collectionWideImage.realCollection').attr('src','https://cdn.shopify.com/s/files/1/0878/1816/files/NAU_' + collection + '_Tablet.jpg?13282905410271515286');

  } else {
    
    $('#collectionWideImage.realCollection').attr('src','https://cdn.shopify.com/s/files/1/0878/1816/files/NAU_' + collection + '_Desktop.jpg?13282905410271515286');

    
  }
  
});
  
 $(window).resize(function() {  
  
  var wi = $(window).width();

  var collection = $('.breadcrumbs span:last-child').text();

  collection = collection.replace(/\s+/g, '_');
  collection = collection.replace('&','');
  collection = collection.replace('__','_');

  
  if (wi < 541) {
    
    $('#collectionWideImage.realCollection').attr("src","https://cdn.shopify.com/s/files/1/0878/1816/files/NAU_" + collection + "_Mobile.jpg?13282905410271515286");
    
  } else if (wi < 1021) {
    
    
   $('#collectionWideImage.realCollection').attr('src','https://cdn.shopify.com/s/files/1/0878/1816/files/NAU_' + collection + '_Tablet.jpg?13282905410271515286');

  } else {
    
    $('#collectionWideImage.realCollection').attr('src','https://cdn.shopify.com/s/files/1/0878/1816/files/NAU_' + collection + '_Desktop.jpg?13282905410271515286');

    
  }
  
});



//Lookbook

;

  
$(window).load(function() {  
  
  var wi = $(window).width();


   if (wi < 541) {
    
	if(window.location.href.indexOf("page1") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page1-mobile.jpg?v=32960360426785055121462130040");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page2") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page2-mobile.jpg?v=32960360426785055121462130041");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page3") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page4") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page5") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page6") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     	if(window.location.href.indexOf("page7") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page8") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page9") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page10") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page11") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page12") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page12-mobile.jpg?0");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page13") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page14") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page15") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page16") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page17") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page18") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page19") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page20") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page20-mobile.jpg?v=32960360426785055121462130042");                                             
    ;
      
    }
  
  } else if (wi < 1021) {
    
       	if(window.location.href.indexOf("page1") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page1-tablet.jpg?v=90652601592344994301462130041");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page2") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page2-tablet.jpg?v=90652601592344994301462130042");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page3") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page4") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page5") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page6") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     	if(window.location.href.indexOf("page7") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page8") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page9") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page10") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page11") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page12") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page13") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page14") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page15") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page16") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page17") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page18") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page19") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page20") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page20-tablet.jpg?v=90652601592344994301462130043");                                             
    ;
      
    }
    
  } else {
                                                  
   	if(window.location.href.indexOf("page1") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page1-desktop.jpg?v=9276600109178707221462130040");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page2") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page2-desktop.jpg?v=9276600109178707221462130041");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page3") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page4") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page5") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page6") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     	if(window.location.href.indexOf("page7") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page8") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page9") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page10") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page11") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page12") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page13") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page14") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page15") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page16") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page17") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page18") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page19") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page20") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page20-desktop.jpg?v=9276600109178707221462130042");                                             
    ;
      
    }
    
  }
  
});
  
$(window).resize(function() {  
  
   var wi = $(window).width();


   if (wi < 541) {
    
	if(window.location.href.indexOf("page1") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page1-mobile.jpg?v=32960360426785055121462130040");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page2") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page2-mobile.jpg?v=32960360426785055121462130041");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page3") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page4") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page5") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page6") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     	if(window.location.href.indexOf("page7") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page8") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page9") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page10") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page11") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page12") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page12-mobile.jpg?0");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page13") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page14") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page15") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page16") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page17") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page18") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page19") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page20") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page20-mobile.jpg?v=32960360426785055121462130042");                                             
    ;
      
    }
  
  } else if (wi < 1021) {
    
       	if(window.location.href.indexOf("page1") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page1-tablet.jpg?v=90652601592344994301462130041");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page2") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page2-tablet.jpg?v=90652601592344994301462130042");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page3") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page4") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page5") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page6") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     	if(window.location.href.indexOf("page7") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page8") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page9") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page10") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page11") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page12") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page13") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page14") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page15") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page16") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page17") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page18") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page19") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page20") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page20-tablet.jpg?v=90652601592344994301462130043");                                             
    ;
      
    }
    
  } else {
                                                  
   	if(window.location.href.indexOf("page1") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page1-desktop.jpg?v=9276600109178707221462130040");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page2") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page2-desktop.jpg?v=9276600109178707221462130041");                                             
    ;
      
    }
     
     	if(window.location.href.indexOf("page3") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page4") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page5") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page6") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     	if(window.location.href.indexOf("page7") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page8") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page9") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page10") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page11") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
     
     	if(window.location.href.indexOf("page12") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page13") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page14") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page15") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page16") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page17") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page18") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page19") > -1) {
   
             
             
    $('#collectionWideImage.lookbookBanner').remove();
    $('#nextImageArrow').remove();                                                 
    $('#prevImageArrow').remove();                          
                                                                        
    ;
      
    }
    
    if(window.location.href.indexOf("page20") > -1) {
   
      ;
                                                                                                              
                                   
    $('#collectionWideImage.lookbookBanner').attr("src","//cdn.shopify.com/s/files/1/1171/6424/t/5/assets/page20-desktop.jpg?v=9276600109178707221462130042");                                             
    ;
      
    }
    
  }
  
});
  
  

$(window).load(function() {  
  
  
$(".lookbookBanner").load(function(){

 var height = $(this).height();


 $('#loobookImageBorder').height(height * 1.057142857142857);
 //$('#loobookImageBorder').css('border','1px solid #000');

  $('#nextImageArrow').css('top',height * 0.2472858866103739);  
  
  $('#prevImageArrow').css('top',height * 0.2472858866103739);  
  
  $('#nextImageArrow').css('padding-top',height * 0.5138721351025332);  
  $('#nextImageArrow').css('padding-bottom',height * 0.5138721351025332);  

  $('#prevImageArrow').css('padding-top',height * 0.5138721351025332);  
  $('#prevImageArrow').css('padding-bottom',height * 0.5138721351025332);   
  
});
  
});
      
      
$(window).resize(function() {  
  
$(".lookbookBanner").load(function(){

 var height = $(this).height();


 $('#loobookImageBorder').height(height * 1.057142857142857);
// $('#loobookImageBorder').css('border','1px solid #000');

  $('#nextImageArrow').css('top',height * 0.2472858866103739);  
  
  $('#prevImageArrow').css('top',height * 0.2472858866103739);  
  
  $('#nextImageArrow').css('padding-top',height * 0.5138721351025332);  
  $('#nextImageArrow').css('padding-bottom',height * 0.5138721351025332);  

  $('#prevImageArrow').css('padding-top',height * 0.5138721351025332);  
  $('#prevImageArrow').css('padding-bottom',height * 0.5138721351025332);  

  
});
  
});

$( document ).ready(function() {
   
  if(window.location.href.indexOf("page" + 20) < 1) {
          
      $('#loobookImageBorder').click(function() {

        for ( var i=1; i < 20 ; i++) {
          
       if(window.location.href.indexOf("page" + i) > -1) {
                

        window.location.href = "/collections/lookbook-page" + parseInt(i+1);
     
            }

        }

  });
          
        }
        
  
        $('a#prevArrow').click(function() {

        for ( var i=1; i < parseInt(20 + 1) ; i++) {
          
       if(window.location.href.indexOf("page" + i) > -1) {
                

        window.location.href = "/collections/lookbook-page" + parseInt(i-1);
     
            }

        }

  });
  
          $('a#nextArrow').click(function() {

        for ( var i=1; i < parseInt(20 + 1); i++) {
          
       if(window.location.href.indexOf("page" + i) > -1) {
                

        window.location.href = "/collections/lookbook-page" + parseInt(i+1);
     
            }

        }

  });
});

;


// Border Trigger for LookBook


$(window).load(function() {

if(window.location.href.indexOf("lookbook-page1") > -1) {

 ;

		  $('#loobookImageBorder').css('border','1px solid #000');

  ;
}
  
if(window.location.href.indexOf("lookbook-page2") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page3") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page4") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page5") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page6") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page7") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page8") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page9") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page10") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page11") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page12") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page13") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page14") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page15") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page16") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page17") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page18") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page19") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page20") > -1) {

    
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  });

$(window).resize(function() {

if(window.location.href.indexOf("lookbook-page1") > -1) {

 ;

		  $('#loobookImageBorder').css('border','1px solid #000');

  ;
}
  
if(window.location.href.indexOf("lookbook-page2") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page3") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page4") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page5") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page6") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page7") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page8") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page9") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page10") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page11") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page12") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page13") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page14") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page15") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page16") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page17") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page18") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page19") > -1) {

 
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  if(window.location.href.indexOf("lookbook-page20") > -1) {

    
  
	  $('#loobookImageBorder').css('border','none');

	  ;
}
  
  });



$(document).ready(function() {  
  
    $("a#linkTitle").each(function(){
 
    var collectionLink = $(this).attr('href');

  collectionLink = collectionLink.replace(/\s+/g, '-');
  collectionLink = collectionLink.replace('&','-');
  collectionLink = collectionLink.replace('---','-');
  
 $(this).attr('href',  collectionLink);  
      
  });     
  
   $("a#linkTitleMobile").each(function(){
 
    var collectionLink = $(this).attr('href');

  collectionLink = collectionLink.replace(/\s+/g, '-');
  collectionLink = collectionLink.replace('&','-');
  collectionLink = collectionLink.replace('---','-');
  
 $(this).attr('href',  collectionLink);  
      
  });     

  
    });


//Reviews



  $(window).load(function() {
      

  var first = $('.yotpo-default-button.write-review-button.write-first-review-button');  
  $('h6#ratingsText').after(first); 
  first.val('Write the first review');
    
  var stars = $('.yotpo-stars-and-sum-reviews');
    
   var reviews = $('.yotpo-sum-reviews span');

     if((reviews).length > 0){
    
       var onlyStars = $('.yotpo-stars');
       
       $(onlyStars).css('float','right');
      
       $('h6#ratingsText').after(stars); 
       
       $(stars).css('width','100%');
       $(stars).css('float','left');

       $(reviews).prepend("Read " );
       
       var writeReviewLink = ('.yotpo-default-button.yotpo-icon-btn.pull-right.yotpo-hidden-mobile.write-button.write-review-button');

       var readReviewLink = ('.yotpo-sum-reviews');
       
       $(writeReviewLink).css('float','left');
       $(writeReviewLink).css('text-decoration','underline');
       $(writeReviewLink).css('margin-left','2%');
       $(writeReviewLink).css('padding-left','2%');
	   $(writeReviewLink).css('border-left','1px solid #5c5c5c');

       $(readReviewLink).css('float','left');
       $(readReviewLink).css('color','#000');
       $(readReviewLink).css('text-decoration','underline');
       $(readReviewLink).css('margin-right','0%');

       $('.yotpo-display-wrapper .yotpo-default-button.yotpo-icon-btn.pull-right.yotpo-hidden-mobile.write-button.write-review-button').remove();
     }
    
  if((first).length > 0){
    
    $(first).after(stars); 
    
   $('.yotpo-default-button.yotpo-icon-btn.pull-right.yotpo-hidden-mobile.write-button.write-review-button').remove();
    
  }
    

  $("span.yotpo-icon-button-text").click(function() {
  $("html, body").animate({ scrollTop: $('.yotpo-main-widget').offset().top }, 1750);
  });

 
  $("span.yotpo-sum-reviews").click(function() {
  $("html, body").animate({ scrollTop: $('.yotpo-main-widget').offset().top }, 1750);
    return false;
  });
    
     
  $(".yotpo-default-button.write-review-button.write-first-review-button").click(function() {
  $("html, body").animate({ scrollTop: $('.yotpo-main-widget').offset().top }, 1750);
    return false;
  });
    
        $( "select.single-option-selector" ).change(function() {
  $(".yotpo-default-button.write-review-button.write-first-review-button").attr('value','Write the first review');
});
    
    
});

//Pop-up Newsletter
$(window).load(function(e) {

    function openNewsletterPopup() {
  
      setTimeout( function() {
     
        
 $('#sign_up').lightbox_me({
        centered: true,
         overlayCSS:	{background: 'black', opacity: .8},
     	 onLoad: function() { 
            $('#sign_up').css('max-width','600');
            }
        });
      }, 
      2*1000);
    }

    $(function() {
      var popup = $.cookie('popup');
      var cookie_enabled = false;

      if (cookie_enabled && popup == 'open') {
          return false;
      } else {
        openNewsletterPopup();
      }
      if (cookie_enabled) {
        $.cookie('popup', 'open', { expires: 0 });
      }
    });


          
     });
          
        
         

